import Vue from 'vue';

const SEON_CONFIG = Object.freeze({
  SCRIPT_TYPE: 'application/javascript',
  UPLOAD_ERROR: 'Seon script is not loaded.',
});

const DEFAULT_SEON_SCRIPT_URL = 'https://cdn.deviceinf.com/js/v6/agent.umd.js';

class Seon {
  seonUrl;

  seon = null;

  config = null;

  constructor(seonUrl) {
    this.seonUrl = seonUrl;
  }

  set seon(seonInstance) {
    this.seon = seonInstance;
    seonInstance.init();
  }

  set config(config) {
    this.config = config;
  }

  get session() {
    return this.seon.getSession(this.config);
  }

  initSeon = () => {
    if (window.seon) {
      this.seon = window.seon;
      this.config = {
        geolocation: {
          canPrompt: false,
        },
        silentMode: true,
      };
    }
  };

  initScript = () => {
    const seonScript = document.createElement('script', {});
    seonScript.src = this.seonUrl || DEFAULT_SEON_SCRIPT_URL;
    seonScript.type = SEON_CONFIG.SCRIPT_TYPE;
    seonScript.defer = true;
    seonScript.onload = this.initSeon;
    seonScript.onerror = () => new Error(SEON_CONFIG.UPLOAD_ERROR);
    document.head.appendChild(seonScript);
  };
}

export default ({ env }, inject) => {
  const seon = new Seon(env.SEON_SCRIPT_URL);
  Vue.prototype.$seon = seon;
  inject('seon', seon);
};
